import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Price } from '../price.model';

export enum PriceActionTypes {
  LoadPrices = '[Price] Load Prices',
  AddPrice = '[Price] Add Price',
  UpsertPrice = '[Price] Upsert Price',
  AddPrices = '[Price] Add Prices',
  UpsertPrices = '[Price] Upsert Prices',
  UpdatePrice = '[Price] Update Price',
  UpdatePrices = '[Price] Update Prices',
  DeletePrice = '[Price] Delete Price',
  DeletePrices = '[Price] Delete Prices',
  ClearPrices = '[Price] Clear Prices',
  GetPricesFails = '[Price] Get Prices Fails'
}

export class LoadPrices implements Action {
  readonly type = PriceActionTypes.LoadPrices;

  constructor(public payload: any = null) {}
}

export class AddPrice implements Action {
  readonly type = PriceActionTypes.AddPrice;

  constructor(public payload: { price: Price }) {}
}

export class UpsertPrice implements Action {
  readonly type = PriceActionTypes.UpsertPrice;

  constructor(public payload: { price: Price }) {}
}

export class AddPrices implements Action {
  readonly type = PriceActionTypes.AddPrices;

  constructor(public payload: { prices: Price[] }) {}
}

export class UpsertPrices implements Action {
  readonly type = PriceActionTypes.UpsertPrices;

  constructor(public payload: any) {}
}

export class UpdatePrice implements Action {
  readonly type = PriceActionTypes.UpdatePrice;

  constructor(public payload: { price: Update<Price> }) {}
}

export class UpdatePrices implements Action {
  readonly type = PriceActionTypes.UpdatePrices;

  constructor(public payload: any) {}
}

export class DeletePrice implements Action {
  readonly type = PriceActionTypes.DeletePrice;

  constructor(public payload: { id: string }) {}
}

export class DeletePrices implements Action {
  readonly type = PriceActionTypes.DeletePrices;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearPrices implements Action {
  readonly type = PriceActionTypes.ClearPrices;
}

export class GetPricesFails implements Action {
  readonly type = PriceActionTypes.GetPricesFails;
}

export type PriceActions =
 LoadPrices
 | AddPrice
 | UpsertPrice
 | AddPrices
 | UpsertPrices
 | UpdatePrice
 | UpdatePrices
 | DeletePrice
 | DeletePrices
 | ClearPrices
 | GetPricesFails;
